// The first two workouts, chosen by the owner (docs/starter-workouts.md, 2026-10-11). Ids are stable.
// Kettlebell Full Body is our own summary of a Gymshark workout; Bodyweight Basics is the owner's routine.
import type { Workout } from '../types';
import { ids } from './plan';

export const STARTER_WORKOUTS: Workout[] = [
  {
    id: 'kettlebell_full_body',
    name: 'Kettlebell Full Body',
    description: 'A full-body kettlebell circuit: swings, squat to press, rows, deadlifts and lunges, 40 seconds on and 20 off, three rounds.',
    level: 'beginner',
    focus: 'full_body',
    equipment: ['kettlebell'],
    xp: 60,
    source: { label: 'Our summary of a Gymshark workout', url: 'https://row.gymshark.com/blog/article/full-body-kettlebell-workout' },
    warmupId: 'general',
    cooldownId: 'full_body',
    sections: [
      { id: 'main', kind: 'main', format: { kind: 'circuit', rounds: 3, workSec: 40, restSec: 20 }, blocks: ids('main', [
        { exerciseId: 'kettlebell_swing' },
        { exerciseId: 'goblet_squat_press' },
        { exerciseId: 'renegade_row' },
        { exerciseId: 'kettlebell_deadlift' },
        { exerciseId: 'reverse_lunge_curl' },
      ]) },
    ],
  },
  {
    id: 'bodyweight_basics',
    name: 'Bodyweight Basics',
    description: 'A 20-minute routine without equipment: plank, squats, push-ups, single-leg squats and core, three rounds.',
    level: 'intermediate',
    focus: 'full_body',
    equipment: ['bodyweight'],
    xp: 45,
    // The owner's own routine stays as he wrote it, without a suggested warm-up or cool-down; one can be added on
    // the start screen (2026-10-14).
    source: { label: 'Our own' },
    sections: [
      { id: 'main', kind: 'main', format: { kind: 'circuit', rounds: 3, workSec: 40, restSec: 20, roundRestSec: 60 }, blocks: ids('main', [
        { exerciseId: 'plank' },
        { exerciseId: 'squat' },
        { exerciseId: 'push_up' },
        { exerciseId: 'single_leg_squat', note: 'alternate legs' },
        { exerciseId: 'lying_leg_lowers' },
        { exerciseId: 'superman' },
      ]) },
    ],
  },
];
